import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DateRangeColumnFilterComponent } from './components/date-range-column-filter/date-range-column-filter.component';
import { DeleteValidatorComponent } from './components/delete-validator/delete-validator.component';
import { HeaderComponent } from './components/header/header.component';
import { LoadingComponent } from './components/loading/loading.component';
import { MobileNavigationComponent } from './components/mobile-navigation/mobile-navigation.component';
import { NoAccessComponent } from './components/no-access/no-access.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { WarningPopupComponent } from './components/warning-popup/warning-popup.component';
import { GeaLibraryModule } from './gea-library.module';
import { PrimeNGModule } from './prime-ng.module';

@NgModule({
  declarations: [
    DateRangeColumnFilterComponent,
    DeleteValidatorComponent,
    HeaderComponent,
    LoadingComponent,
    NoAccessComponent,
    SidebarComponent,
    WarningPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    MobileNavigationComponent,
    GeaLibraryModule,
    PrimeNGModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    MobileNavigationComponent,
    DateRangeColumnFilterComponent,
    DeleteValidatorComponent,
    HeaderComponent,
    LoadingComponent,
    NoAccessComponent,
    SidebarComponent,
    WarningPopupComponent
  ]
})
export class SharedModule { }
